<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{'map.sidebar.ebw_layers_configurator.legend' | translate}}
  <button class="custom-close" mat-icon-button color="primary" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</h1>
<div mat-dialog-content>
  <div class="detail"> {{data.title}}</div>
  <img class="ml-auto" [src]="data.image">
</div>
<!-- <div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
</div> -->
